__turbopack_context__.v({
  "root": "PostBody-module-scss-module__xGHW4a__root",
});
